<script setup lang="ts">/**
 * Content:
 * Placement
 * Openings and Closings
 * Family Company - Philosophy
 * Experience,Quality,
 * Master and TÜV
 * Team and photos
 *
 */

import * as CookieConsent from 'vanilla-cookieconsent';
import {onBeforeUnmount, onMounted, ref} from "vue";
import '@/assets/styles/about.css'


// Später auslagern
interface TeamMember {
  name: string;
  role: string;
  img?: string;
  text: string;
  certificate?: string;
}

const selected = ref<TeamMember | null>(null);


const team: TeamMember[] = [
  {
    name: "Max Mustermann",
    role: "Geschäftsführer & Kraftfahrzeugtechnikermeister",
    text: "Hallo! Ich bin Max, der beispielhafte Gründer dieser Musterwerkstatt.",
    certificate: '@/assets/team/teamleitung.jpeg'
  },
  {
    name: "Erika Musterfrau",
    role: "KFZ-Mechatroniker",
    text: "Hey! Ich bin Erika und halte eure Autos am Laufen.",
  }
];

const showPopup = (member: TeamMember) => {
  selected.value = member;
};

const closePopup = () => {
  selected.value = null;
};

const acceptedGoogleMaps = ref(false);

function updateConsent() {
  acceptedGoogleMaps.value =
      CookieConsent.acceptedCategory("external");
}

function openCookieSettings() {
  CookieConsent.showPreferences();
}

onMounted(() => {
  updateConsent();
  window.addEventListener("cookie-consent-changed", updateConsent);
});

onBeforeUnmount(() => {
  window.removeEventListener("cookie-consent-changed", updateConsent);
});

</script>

<template>
  <div class="about">

    <section class="team">
      <div class="team-wrapper">
        <h1>Meet the Team mit einem Klick</h1>

        <div class="team-grid">
          <div
              class="team-card card"
              v-for="member in team"
              :key="member.name"
              @click="showPopup(member)"
          >
            <!--            <img :src="member.img" :alt="member.name"/>-->
            <h3>{{ member.name }}</h3>
            <p>{{ member.role }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="card">
        <h2>Über unser Unternehmen</h2>
        Seit unserer Gründung im Jahr 2024 stehen wir für zuverlässigen Service, moderne Technik und echte Kundennähe.
        Bereits 2025 konnten wir unser Team erweitern – ein wichtiger Schritt, um unseren Service weiter auszubauen und
        noch schneller für unsere Kunden da zu sein.
        Als Meisterbetrieb kümmern wir uns um Fahrzeuge aller Marken. Neben klassischen Wartungs- und Reparaturarbeiten
        bieten wir unter anderem auch Getriebeölspülungen an – eine Leistung, die über den herkömmlichen
        Getriebeölwechsel hinausgeht und von vielen Betrieben nicht angeboten wird. Dabei arbeiten wir stets mit
        möglichst moderner Technik, um Ihr Fahrzeug optimal zu betreuen.
        Was uns besonders auszeichnet, ist unser persönlicher Service: Bei uns sind Sie keine Nummer wie im großen
        Autohaus. Wir nehmen uns Zeit für Ihre Anliegen, beraten ehrlich und unkompliziert und gehen verantwortungsvoll
        mit jedem Fahrzeug um. Eine schnelle Terminvergabe gehört für uns genauso dazu wie transparente Abläufe.
        Als lokal verwurzeltes Unternehmen freuen wir uns über das Vertrauen unserer Kunden. Viele neue Kunden finden
        durch Empfehlungen zu uns, gleichzeitig dürfen wir auch langjährige Kunden weiterhin betreuen. Das bestätigt uns
        in unserer Arbeit – denn bei uns wird Service noch großgeschrieben.
        Wir freuen uns darauf, auch Sie persönlich bei uns begrüßen zu dürfen.
      </div>
    </section>

    <section class="opening-hours">
      <div class="card">
        <h2>Öffnungszeiten</h2>

        <ul class="opening-list">
          <li><span>Montag – Freitag</span><span>08:00 – 17:00 Uhr</span></li>
          <li class="closed"><span>Samstag & Sonntag</span><span>Geschlossen</span></li>
        </ul>

        <p class="opening-hint">
          Termine außerhalb der Öffnungszeiten nach Vereinbarung.
        </p>
      </div>
    </section>

    <section class="placement">
      <div class="map-card">

        <iframe
            v-if="acceptedGoogleMaps"
            style="border:0;"
            loading="lazy"
            allowfullscreen
            src="https://www.google.com/maps?q=Musterstrasse+12,+12345+Musterstadt&output=embed"
        ></iframe>

        <div v-else class="map-placeholder">
          <p>Google Maps ist deaktiviert</p>
          <button @click="openCookieSettings">
            Einstellungen öffnen
          </button>
        </div>

      </div>
    </section>


    <!-- POPUP -->
    <div v-if="selected" class="popup-overlay" @click.self="closePopup">
      <div class="popup-box">
        <button class="close-btn" type="button" aria-label="Popup schliessen" @click="closePopup">x</button>

        <!--<img :src="selected.img" :alt="selected.name" class="popup-img"/>-->
        <h2>{{ selected.name }}</h2>
        <h4>{{ selected.role }}</h4>
        <!--        <a
                    v-if="selected.certificate"
                    :href="selected.certificate"
                    download
                    class="certificate-link"
                >
                  Meister-Brief
                </a>-->
        <p class="popup-text">{{ selected.text }}</p>
      </div>
    </div>

  </div>
</template>

